import React, { useEffect, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom"; // Added useHistory
import axios from "axios";

const ProductImage = () => {
  const { id, name } = useParams();
  const history = useHistory(); // Initialize history hook for direct redirection
  const [ProductImages, setProductImages] = useState([]);
  const [sortBy, setSortBy] = useState("title-ascending");
  const [sortedProducts, setSortedProducts] = useState([]);
  const [activeView, setActiveView] = useState("grid");
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const fetchProductImages = () => {
    axios
      .post(`${BASE_URL}/api/category_wise_product`, {
        category_id: id,
      })
      .then((response) => {
        // Check if sub-products actually exist
        if (response.data.product && response.data.product.length > 0) {
          setProductImages(response.data.product);
          const sorted = [...response.data.product].sort((a, b) =>
            a.name.localeCompare(b.name)
          );
          setSortedProducts(sorted);
        } else {
          /* 🔥 LOGIC FALLBACK CRITICAL CHECK:
            If 'response.data.product' is empty, this category has no sub-products!
            Bypass this page completely and forward the main Category ID and Name 
            directly to your Flipbook Catalogue page.
          */
          history.replace(`/product_catalogue/main_${id}/${name}`);
        }
      })
      .catch((err) => {
        console.error("Error fetching sub-products", err);
      });
  };

  useEffect(() => {
    fetchProductImages();
  }, [id]); // Added dependency to re-run if ID changes

  const handleSortChange = (e) => {
    const value = e.target.value;
    setSortBy(value);
    let sorted = [...ProductImages];
    switch (value) { // Fixed bug: was checking 'sortBy' state instead of current 'value'
      case "title-descending":
        sorted.sort((a, b) => b.name.localeCompare(a.name));
        break;
      case "title-ascending":
        sorted.sort((a, b) => a.name.localeCompare(b.name));
        break;
      default:
        break;
    }
    setSortedProducts(sorted);
  };

  return (
    <main className="main-content site-wrapper-reveal">
      <section
        className="page-content-area "
        style={{
          backgroundImage: `url("../../assets/img/product_img_cover.jpg")`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-title-content text-center">
                <h2 className="title">Product Images</h2>
                <div className="bread-crumbs">
                  <Link to="/">
                    Home<span className="breadcrumb-sep">/</span>
                  </Link>
                  <span className="active">Product Images</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="product-area featured-product-area">
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-lg-6 m-auto">
              <div className="section-title text-center">
                <h2 className="title">{name ? decodeURIComponent(name) : ""}</h2>
              </div>
            </div>
            <div className="col-12">
              <div className="shop-topbar-wrapper">
                <div className="collection-shorting">
                  <div className="shop-topbar-left">
                    <div className="view-mode">
                      <nav>
                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                          <button
                            className={`nav-link ${activeView === "grid" ? "active" : ""}`}
                            id="nav-grid-tab"
                            type="button"
                            onClick={() => setActiveView("grid")}
                          >
                            <i className="fa fa-th"></i>
                          </button>
                          <button
                            className={`nav-link ${activeView === "list" ? "active" : ""}`}
                            id="nav-list-tab"
                            type="button"
                            onClick={() => setActiveView("list")}
                          >
                            <i className="fa fa-list-ul"></i>
                          </button>
                        </div>
                      </nav>
                    </div>
                    <p>
                      Showing 1 - {sortedProducts.length} of {ProductImages.length} results
                    </p>
                  </div>
                  <div className="product-sorting-wrapper">
                    <div className="product-show">
                      <label htmlFor="SortBy">Sort by</label>
                      <select
                        className="form-select"
                        id="SortBy"
                        value={sortBy}
                        onChange={handleSortChange}
                      >
                        <option value="title-ascending">Alphabetically, A-Z</option>
                        <option value="title-descending">Alphabetically, Z-A</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* GRID VIEW */}
          {activeView === "grid" ? (
            <div className="row">
              {sortedProducts.map((element) => (
                <div className="col-md-6 col-xl-4" key={element.id}>
                  <div className="product-item">
                    <div className="product-thumb">
                    {/* /* Inside your normal Grid/List view loops for submenu items */ }
                      <Link to={`/product_catalogue/${element.id}/${element.name}`}>
                        <img src={`${BASE_URL}/${element.image}`} alt={element.name} className="product-img" />
                      </Link>
                    </div>
                    <div className="product-info">
                      <h4 className="sub_title">
                        <Link to={`/product_catalogue/${element.id}/${element.name}`}>
                          {element.name}
                        </Link>
                      </h4>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            /* LIST VIEW */
            <div className="list-view">
              {sortedProducts.map((element) => (
                <div className="product-item d-flex align-items-center border p-3 mb-3" key={element.id}>
                  <div className="product-thumb" style={{ marginRight: "3rem" }}>
                    /* Inside your normal Grid/List view loops for submenu items */
                    <Link to={`/product_catalogue/${element.id}/${element.name}`}>
                      <img src={`${BASE_URL}/${element.image}`} alt={element.name} className="product-img" />
                    </Link>
                  </div>
                  <div className="product-info">
                    <h4 className="title">
                      <Link to={`/product_catalogue/${element.id}/${element.name}`}>
                        {element.name}
                      </Link>
                    </h4>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default ProductImage;
